import { jsx as _jsx } from "react/jsx-runtime";
import { NodeType } from "@reside/forms/dist/templateTypes";
import { Button } from "../../button";
import { Modal, ModalContent } from "../../modal";
import { BlockField } from "../../form-blocks";
export const ModalRenderer = ({ staticContentId, staticContent, children, }) => {
    if (!staticContent) {
        return null;
    }
    return (_jsx(Modal, { trigger: ref => (_jsx(Button, { ref: ref, testId: staticContentId, type: "link", underline: true, children: children })), children: () => {
            const content = staticContent.find(content => content.id === staticContentId);
            return (_jsx(ModalContent, { children: content?.children.map(block => (_jsx(BlockField, { block: 
                    // TODO: pass to each block, if static content is used on more nodes besides paragraph.
                    block.type === NodeType.PARAGRAPH
                        ? { staticContent, ...block }
                        : block }, block.id))) }));
        } }));
};
